import { FunctionComponent } from 'react';
import { useMediaQuery } from '@material-ui/core';
import { InvoiceListRecord } from '@spike/invoice-model';
import Button from 'components/UI/V3/Button/Button';
import GenericModal from 'components/UI/V3/Modals/GenericModal';
import { mediaQueries } from 'hooks/useBreakpoints';
import styles from './DeleteInvoiceModal.module.scss';

export interface DeleteInvoiceModalProps {
    invoice: InvoiceListRecord | null;
    deleting?: boolean;
    zIndex?: number;
    onClose: () => void;
    onConfirm: () => void;
}

const DeleteInvoiceModalContent: FunctionComponent<{
    deleting?: boolean;
    zIndex?: number;
    onClose: () => void;
    onConfirm: () => void;
}> = ({ deleting = false, zIndex, onClose, onConfirm }) => {
    const isMobile = useMediaQuery(`(max-width:${mediaQueries.down.sm})`);

    return (
        <GenericModal
            fullScreen={isMobile}
            zIndex={zIndex}
            onClose={deleting ? undefined : onClose}
            footer={
                <div className={styles.footer}>
                    <div className={styles.footerAction}>
                        <Button
                            size="large"
                            className={styles.button}
                            label="Cancel"
                            onClick={onClose}
                            variant="black"
                            disabled={deleting}
                        />
                    </div>
                    <div className={styles.footerAction}>
                        <Button
                            label={deleting ? 'Deleting...' : 'Yes'}
                            size="large"
                            className={styles.button}
                            onClick={onConfirm}
                            variant="danger"
                            isLoading={deleting}
                            disabled={deleting}
                        />
                    </div>
                </div>
            }
            className={styles.modal}
        >
            <div className={styles.content}>
                <span className={styles.title}>Delete Invoice?</span>
                <p className={styles.description}>Are you sure want to delete this invoice?</p>
            </div>
        </GenericModal>
    );
};

export const DeleteInvoiceModal: FunctionComponent<DeleteInvoiceModalProps> = ({
    invoice,
    deleting,
    zIndex,
    onClose,
    onConfirm
}) => {
    if (!invoice) {
        return null;
    }

    return (
        <DeleteInvoiceModalContent
            key={invoice.uuid}
            deleting={deleting}
            zIndex={zIndex}
            onClose={onClose}
            onConfirm={onConfirm}
        />
    );
};

export default DeleteInvoiceModal;
